var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9 1.3L12.7 3.1C13.1 3.5 13.1 4.1 12.7 4.5L5.2 12H2V8.8L9.5 1.3C9.9 0.9 10.5 0.9 10.9 1.3ZM12 3.8L10.2 2L8.7 3.5L10.5 5.3L12 3.8ZM3 9.2V11H4.8L9.8 6L8 4.2L3 9.2ZM1 14V13H15V14H1Z",
    fill: "#891515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditHover);
export default __webpack_public_path__ + "static/media/edit_hover.9e287d7c548434d6feffd8f2ba8ec52e.svg";
export { ForwardRef as ReactComponent };